import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Post from '../../../Common/PostList/Post';
import Comments from '../../../Common/Comments';
import { IconArrowLeft } from '../../../Common/Icon';
import { usePostGetById } from '../../../../hooks/api/posts';
import { Post as PostType } from '../../../../store/post';

import styles from './index.module.scss';

export default function ShareYourTwoCentsViewContent(): React.ReactElement {
  const { id } = useParams();
  const postGetById = usePostGetById(id);
  const navigate = useNavigate();
  const [list, setList] = useState<PostType | null>(null);

  const { data, loading, error } = postGetById;

  useEffect(() => {
    if (!loading && !error && data) {
      setList(data);
    }
  }, [data, loading, error]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <Button
          className={styles.btnBack}
          type="text"
          onClick={() => navigate('/share-your-two-cents')}
        >
          <IconArrowLeft className={styles.btnBackIcon} />
          Back to Share Your Two Cents
        </Button>
        <div className={styles.content}>
          {list ? (
            <Post post={list} isHeader isPostSingle setPost={setList} />
          ) : null}
          <div style={{ marginTop: 20 }}>
            <Comments
              filter={{
                postId: id,
                entity: 'post',
              }}
              ownerID={data?.business?.ownerId}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
